<template>
    <div class="flex justify-center -mb-16">

        <div class="mr-16 flex flex-col">

            <add-component-button class="flex-grow" type="team" icon="groups">
                {{ $t('site_editor.team.description') }}
            </add-component-button>

            <add-component-button class="h-220 flex-none" type="quotes" icon="format-quote">
                {{ $t('site_editor.quotes.description') }}
            </add-component-button>

        </div>

        <div class="mr-16 flex flex-col">

            <add-component-button class="h-220 flex-none" type="perks" icon="sports-esports">
                {{ $t('site_editor.perks.description') }}
            </add-component-button>

            <add-component-button class="flex-grow" type="values" icon="genetics">
                {{ $t('site_editor.values.description') }}
            </add-component-button>

        </div>

        <div class="mr-16 flex flex-col">

            <add-component-button class="h-220 flex-none" type="image" title="image" icon="image">
                {{ $t('site_editor.image.description') }}
            </add-component-button>

            <add-component-button class="h-220 flex-none" type="locations" icon="location-on">
                {{ $t('site_editor.locations.description') }}
            </add-component-button>

            <add-component-button class="h-220 flex-none" type="facts" icon="lightbulb">
                {{ $t('site_editor.facts.description') }}
            </add-component-button>

        </div>

        <div class="mr-16 flex flex-col">

            <add-component-button class="h-220 flex-none" type="gallery" icon="gallery-thumbnail">
                {{ $t('site_editor.gallery.description') }}
            </add-component-button>

            <add-component-button class="h-220 flex-none" type="awards" icon="trophy">
                {{ $t('site_editor.awards.description') }}
            </add-component-button>

            <add-component-button class="h-220 flex-none" type="facebook" icon="facebook">
                {{ $t('site_editor.social.description.facebook') }}
            </add-component-button>

            <!-- Social stuff... -->
            <!-- <div>
                <h3>{{ $t('site_editor.social.title') }}</h3>
                <p>{{ $t('site_editor.social.description') }}</p>
            </div> -->
        </div>

        <div class="mr-16 flex flex-col">

            <add-component-button class="h-220 flex-none" type="video" icon="videocam">
                {{ $t('site_editor.video.description') }}
            </add-component-button>

            <add-component-button class="h-220 flex-none" type="text" icon="title">
                {{ $t('site_editor.text.description') }}
            </add-component-button>

            <add-component-button class="h-220 flex-none" type="twitter" icon="x">
                {{ $t('site_editor.social.description.twitter') }}
            </add-component-button>

            <!-- Social stuff... -->
            <!-- <add-component-inline-button type="facebook">
                {{ $t('site_editor.facebook.title') }}
            </add-component-inline-button>
            <add-component-inline-button type="twitter">
                {{ $t('site_editor.twitter.title') }}
            </add-component-inline-button>
            <add-component-inline-button type="linkedin">
                {{ $t('site_editor.linkedin.title') }}
            </add-component-inline-button>
            <add-component-inline-button type="instagram">
                {{ $t('site_editor.instagram.title') }}
            </add-component-inline-button> -->
        </div>

    </div>
</template>

<script>
import AddComponentButton from './AddComponentButton.vue';
import AddComponentInlineButton from './AddComponentInlineButton.vue';

export default {
    components: {
        'add-component-button': AddComponentButton,
        'add-component-inline-button': AddComponentInlineButton,
    },
}
</script>
